import React from 'react';
import { Checkbox } from '@mui/material';
import { t } from 'i18next';

const CheckBox = ({ disabled, className, label, checked, onClick, target, href, text, error, id, name }) => {

    return (
            <div className={"CheckLabel " + error}>
                <Checkbox
                    id={id || `checkbox-${label}`}
                    name={name || `checkbox-${label}`}
                    disabled={disabled}
                    className={className}
                    aria-labelledby={`label-${label}`}
                    checked={checked}
                    onClick={onClick}
                />
                <label id={`label-${label}`} htmlFor={id || `checkbox-${label}`}>
                    {t(label)}
                    {href && <a target={target} href={href}>{t(text)}</a>}
                </label>
            </div>
    )
}
export default CheckBox
